<div class="row pt-4 mb-5">
    <div class="card p-3 mb-4">
        <form role="form" [formGroup]="formPreCadastroCandidato" (ngSubmit)="envioPreCandidato()">
            <h5 class="mb-0">Edição de Pré-candidatura</h5>
            <hr>
            <div class="row">
                <div class="col-6">
                    <div class="form-group">
                        <strong for="exampleInputPassword1">Nome completo*</strong>
                        <input type="text" min="1" class="form-control" formControlName="nome"
                            placeholder="Digite o nome e sobrenome do precandidato">
                        <span class="alert alert-danger mr-2 ml-2 mt-n1 p-1"
                            *ngIf="!formPreCadastroCandidato.get('nome').valid && ( formPreCadastroCandidato.get('nome').touched || isSubmit )">
                            <small>O campo nome é obrigatório.</small>
                        </span>
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-group">
                        <strong for="emailPreCandidato">Email*</strong>
                        <input type="text" (blur)="validarEmailPreCandidato($event.target.value)" class="form-control"
                            name="emailPreCandidato" id="emailPreCandidato" formControlName="emailPreCandidato"
                            placeholder="Digite o email do precandidato">
                            <span class="alert alert-danger mr-2 ml-2 mt-n1 p-1"
                            *ngIf="!formPreCadastroCandidato.get('emailPreCandidato').valid && ( formPreCadastroCandidato.get('emailPreCandidato').touched || isSubmit )">
                            <small>O campo e-mail é obrigatório.</small>
                        </span>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <div class="form-group">
                        <strong for="exampleInputPassword1">CPF</strong>
                        <input type="text" min="1" class="form-control" formControlName="cpf" mask="000.000.000-00"
                            placeholder="999.999.999-99">
                        <span class="alert alert-danger mr-2 ml-2 mt-n1 p-1"
                            *ngIf="!formPreCadastroCandidato.get('cpf').valid && ( formPreCadastroCandidato.get('cpf').touched || isSubmit )">
                            <small>CPF inválido!</small>
                        </span>
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-group">
                        <strong>Cargo*</strong>
                        <select class="form-control" formControlName="cargo">
                            <option value="">Selecione</option>
                            <option *ngFor="let c of listaCargos" value="{{c.id}}">
                                {{c.nome}}
                            </option>
                        </select>
                        <span class="alert alert-danger mr-2 ml-2 mt-n1 p-1"
                            *ngIf="!formPreCadastroCandidato.get('cargo').valid && ( formPreCadastroCandidato.get('cargo').touched || isSubmit )">
                            <small>O campo cargo é obrigatório.</small>
                        </span>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <div class="form-group">
                        <strong>Foto *</strong>
                        <span class="alert alert-danger mr-2 ml-2 mt-n1 p-1"
                *ngIf="!validaFoto && isSubmit">
                    <small>A foto é obrigatória!</small>
                </span>
                <span class="alert alert-danger mr-2 ml-2 mt-n1 p-1"
                *ngIf="!validaTamanhoFoto && isSubmit">
                    <small>O tamanho máximo da foto é 3.5 MB!</small>
                </span>
                        <input (click)="fixAlterarImg(this)" class="form-control
                                    ext-input p-8" id="imagePreCandidato" name="imageUrl" type="file" accept="image/*"
                            (change)="handleInputChange($event)" />
                        <div class="col-5" *ngIf="imageSrc">
                            <div class="form-group">
                                <label></label>
                                <img [src]="imageSrc" style="max-width:100%;max-height:100%" />
                            </div>
                        </div>
                        <span style="font-size: 10px;">Até 3.5MB</span>
                    </div>
                </div>
            </div>
            <div class="mb-3">
                <strong>Currículo *</strong>
                <span class="alert alert-danger mr-2 ml-2 mt-n1 p-1"
                *ngIf="!formPreCadastroCandidato.get('precandidatocurriculum').valid && ( formPreCadastroCandidato.get('precandidatocurriculum').touched || isSubmit )">
                    <small>Campo currículo/descrição é obrigatório!</small>
                </span>
                <angular-editor id="precandidatocurriculum" formControlName="precandidatocurriculum"
                    [config]="editorConfig"></angular-editor>
                <!--  <span class="alert alert-danger mr-2 ml-2 mt-n1 p-1"
                                *ngIf="!formCadastroCandidato.get('curriculum').valid && ( formCadastroCandidato.get('curriculum').touched || isSubmit )">
                                <small>Campo currículo/descrição é obrigatório!</small>
                            </span>  -->
            </div>
            <button type="submit" class="btn
                        btn-success btn-custom">Salvar</button>
        </form>
    </div>
</div>

<div class="modal fade" id="myModal2" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center" id="exampleModalLabel">Atenção!</h2>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <h4>O currículum do precandidato não foi informado, deseja prosseguir com o cadastro?</h4>
            </div>
            <div class="modal-footer text-center">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                    (click)="prosseguirSemCurriculum()">
                    Sim
                </button>
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="pararSubmit()">
                    Não
                </button>
            </div>
        </div>
    </div>
</div>